import CountUp from "react-countup";

const MetricBox = ({ title, actual, goal, color }) => {
  let bgColor = "#d1dbcf"; // default green
  if (color === "red") bgColor = "#fca5a5";
  if (color === "gray") bgColor = "#e5e7eb";

  const renderAnimatedCount = (val) => {
    if (val == null || val === "") return "$0";
    const num = Number(String(val).replace(/,/g, ''));
    return !isNaN(num) ? <CountUp end={num} separator="," duration={2} prefix="$" /> : `$${val}`;
  };

  return (
    <div className="border px-2 rounded-md shadow-sm" style={{ backgroundColor: bgColor }}>
      <p className="border-b text-center border-gray-400 py-1 head-2 dark-H">{title}</p>

      <div className="p-2 text-center">
        <p className="head-4 dark-H">Actual</p>
        <p className="mb-1">
          {renderAnimatedCount(actual)}
        </p>

        <p className="head-4 dark-H">Goal</p>
        <p>
          {renderAnimatedCount(goal)}
        </p>
      </div>
    </div>
  );
};

export default MetricBox;
